import { useState } from 'react'
import { MODAL_CONSTS } from '../../const/modal-const'
import MainModal from './common/MainModal'
import useToasterHelper from '../../helpers/ToasterHelper'
import { MESSAGES_CONST } from '../../const/messages-const'

// Types

type Props = {
  show: boolean
  handleModal?: any
  dataToPassOn?: {
    alertText?: string
    removeItem: Function
    isBtnOk?: boolean
    submitButtonName?: string
  }
}

const ListRemoveModal = (props: Props) => {
  // Hooks and vars
  const [loading, setLoading] = useState(false)

  const toastFunctions = useToasterHelper()

  const dataToRender = props?.dataToPassOn?.alertText

  // Functions
  const closeModal = () => {
    props.handleModal(false, MODAL_CONSTS.REMOVE_CONFIRMATION)
  }

  const remove = async () => {
    try {
      setLoading(true)
      if (typeof props.dataToPassOn?.removeItem === 'function') {
        await props.dataToPassOn.removeItem?.()
      }
      closeModal()
    } catch (error) {
      setLoading(false)
      toastFunctions.error({
        message: MESSAGES_CONST.SOMETHING_WENT_WRONG,
      })
    }
  }

  return (
    <MainModal
      type="REMOVE_CONFIRMATION"
      size="md"
      show={props.show}
      setHeightAsPerContent={true}
      buttons={
        props.dataToPassOn?.isBtnOk
          ? []
          : [
              {
                label: props.dataToPassOn?.submitButtonName ?? 'Remove',
                className: 'md:!w-[70%] mb-2',
                bgClass: '!bg-SeabiscuitMainThemeColor',
                onClick: remove,
                loading,
                textClass: '!text-white',
                onHoverClass: 'hover:shadow-slate-300',
              },
              {
                label: 'Cancel',
                onClick: closeModal,
                borderClass: 'border-transparent',
                className: 'md:!mb-0 md:!w-[70%]',
                bgClass: '!bg-SeabiscuitLightThemeColor',
                textClass: '!text-SeabiscuitLightTextColor',
                onHoverClass: 'hover:shadow-slate-300',
              },
            ]
      }
    >
      <div className="modal-header flex flex-shrink-0 items-center justify-between rounded-t-md">
        <div className=" pb-2 mx-auto !mt-5 text-SeabiscuitDark200ThemeColor">
          {typeof dataToRender === 'string' ? (
            <h5 className="text-xl leading-normal font-normal">
              {dataToRender ?? 'Are you sure you want to remove?'}
            </h5>
          ) : (
            (dataToRender ?? 'Are you sure you want to remove?')
          )}
        </div>
      </div>
    </MainModal>
  )
}

export default ListRemoveModal
